import * as React from 'react';
import styled from 'styled-components';
const StyleDiv = styled.div ``;
class IconAdd extends React.Component {
    render() {
        return (React.createElement(StyleDiv, { className: this.props.className },
            React.createElement("svg", { onClick: this.props.clicked, width: this.props.width, height: this.props.height, viewBox: "0 0 510 510" },
                React.createElement("g", null,
                    React.createElement("g", { id: "add-circle" },
                        React.createElement("path", { d: "M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M382.5,280.5h-102v102h-51v-102    h-102v-51h102v-102h51v102h102V280.5z" })))),
            this.props.children));
    }
}
;
export default IconAdd;
//# sourceMappingURL=IconAdd.js.map


// WEBPACK FOOTER //
// ./src/components/IconAdd.js